import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerSuccessOptionsAppserviceService } from '../../services/wealthlane-customer-services';

const useGetSourceCompanies = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  const companiesOptions = useQuery(
    ['getCompaniesOptions'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsAllowedSourceCompanies()
      );
    },
    {
      select(data) {
        return data?.map((company) => {
          return {
            label: company.name ?? '',
            value: company.id ?? '',
          };
        });
      },
    }
  );
  return companiesOptions;
};

export default useGetSourceCompanies;
